module.exports = __webpack_public_path__ + "static/freedom-character-018dcc5614f39da2f76af4d20b4f9a7f.png";